module.exports = __webpack_public_path__ + "static/media/MERN.a74926d8.png";